<template>
  <div>
  <div class="min-h-screen bg-darkblue p-4">
    <div class=" bg-white br-10 items-center mb-4 rounded-2xl " >
      <div class="w-full bg-divider  p-3 br-t-10 rounded-t-2xl">
        <span class="text-xxs font-semibold rounded-sm text-black text-center block">{{match.home_team?match.home_team.name:''}} vs {{match.opponent_team ? match.opponent_team.name : ''}}</span>
      </div>
      <form @submit.prevent="submitForm">
        <div class="px-4 border-b border-divider">
          <span class="text-black text-opacity-50 text-sm my-4 block">Can you predict?</span>
            <div class="flex items-center mb-4" v-for="prediction in team_predictions" :key="prediction.id">
            <div class="w-1/3">
              <span :class="`text-black  font-medium text-sm block leading-none ${prediction.id===1 && !can_predict_toss?'text-opacity-50':''}`">{{prediction.title}}</span>
              <!-- <span class="text-orange font-normal text-xxs ">{{match_remaining_time?`(expires in ${match_remaining_time})`:''}}</span> -->
            </div>
            <div class="w-2/3 flex justify-end">
              <div class="custom-radio mr-2 cursor-pointer">
                <label :for="`${prediction.id}_${match.home_team.id}`">
                  <input type="radio" :name="`${prediction.id}`" :id="`${prediction.id}_${match.home_team.id}`" class="appearance-none" v-model="form_data[prediction.id]" :value="match.home_team.id" @change="valueChange" :disabled="prediction.id===1 && !can_predict_toss">
                  <span :for="`${prediction.id}_${match.home_team.id}`"  :class="`text-black ${prediction.id===1 && !can_predict_toss?'text-opacity-10':'text-opacity-30'}  rounded-lg px-2 py-2 uppercase font-semibold flex items-center text-center flex-col`"><i class="">{{getShortForm(match.home_team.name)}}</i><i class=" d-block text-8 mt-1">{{match.home_team.name}}</i></span>
                </label>
              </div>
              <div class="custom-radio cursor-pointer">
                <label :for="`${prediction.id}_${match.opponent_team.id}`">
                  <input type="radio" :name="`${prediction.id}`" :id="`${prediction.id}_${match.opponent_team.id}`" class="appearance-none" v-model="form_data[prediction.id]" :value="match.opponent_team.id" @change="valueChange" :disabled="prediction.id===1 && !can_predict_toss">
                  <span :for="`${prediction.id}_${match.opponent_team.id}`" :class="`text-black ${prediction.id===1 && !can_predict_toss?'text-opacity-10':'text-opacity-30'}  rounded-lg px-2 py-2 uppercase font-semibold flex items-center text-center flex-col`"><i class="">{{getShortForm(match.opponent_team.name)}}</i><i class=" d-block text-8 mt-1">{{match.opponent_team.name}}</i></span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="p-4 pt-6">
          <div class="flex items-center mb-8" v-for="prediction in player_predictions" :key="prediction.id">
            <div class="w-full">
              <span class="text-black  font-medium text-sm block leading-none mb-2">{{prediction.title}}</span>
              <multiselect :name="`${prediction.id}_team`" :id="`${prediction.id}_team`" class="custom-select br-10" v-model="form_data[prediction.id]"  track-by="id"  label="name" :options="players" placeholder="Select Player" @input="valueChange">
              </multiselect>
            </div>
          </div>
          <div class="flex items-center mb-8" v-for="prediction in score_range_predictions" :key="prediction.id">
            <div class="w-full">
              <span class="text-black  font-medium text-sm block leading-none mb-2">{{prediction.title}}</span>
              <multiselect :name="`${prediction.id}_team`" :id="`${prediction.id}_team`" class="custom-select br-10" v-model="form_data[prediction.id]" track-by="id" label="name" :options="score_range" placeholder="Select Score" @input="valueChange">
              </multiselect>
            </div>
          </div>            
          <button type="submit" :class="`btn-login font-bold text-white w-full my-2 p-4 ${formInvalid()?'disabled':''}`" >Save</button>
        </div>
      </form>
    </div>
  </div>
  <Loader v-if="isLoading"/>
  </div>
</template>
<script type="text/javascript">
  import Loader from '../components/Loader.vue';
  import Multiselect from 'vue-multiselect';
  export default {
    components:{
      Loader,
      Multiselect
    },
    data() {
      return {
        isLoading:false,
        match:{},
        match_uuid:'',
        predictions:[],
        team_predictions:[],
        player_predictions:[],
        score_range_predictions:[],
        match_remaining_time:'',
        score_range:[],
        players:[],
        form_data:{},
        is_changed: false,
        can_predict_toss:true
      }
    },
    async mounted(){
      this.match_uuid = this.$route.params.uuid;
      this.isLoading = true;
      await this.fetchMatchFormDetails();
      await this.fetchMatchPredictions();
      this.isLoading = false;
    },
    methods:{
      async fetchMatchFormDetails(){
        try{
          const res = await this.$axios.get(`/ipl/matches/${this.match_uuid}/settings`);
          this.match = res.data ? res.data: {};
          this.predictions = this.match.predictions ? this.match.predictions : [];
          this.can_predict_toss = this.match.can_predict_toss;
          this.player_predictions = this.predictions.filter(prediction => prediction.prediction_type.toLowerCase() === "teamplayer");
          this.team_predictions = this.predictions.filter(prediction => prediction.prediction_type.toLowerCase() === "team")
          this.score_range_predictions = this.predictions.filter(prediction => prediction.prediction_type.toLowerCase() === "scorerange");
          this.score_range = this.match.score_range ? this.match.score_range.map(prediction => ({...prediction,name:`${prediction.min_score} - ${prediction.max_score}`})) : [];
          this.players = res.data.players ? res.data.players : [];
        }catch(err){
          if(err && err.data && err.data.message){
            this.$swal("Loading Failed",err.data.message,"error");
          }else if(err){
            this.$swal("Loading Failed","Something went wrong!","error");
          }
        }
      },
      async fetchMatchPredictions(){
        try{
          const res = await this.$axios.get(`/ipl/matches/${this.match_uuid}/prediction_detail`);
          const data = res.data;
          if(data && data.prediction && data.prediction.length > 0){
            for(let prediction of data.prediction){
              if(prediction.response_id){
                if(prediction.response_type.toLowerCase() === "team"){
                  this.form_data[prediction.prediction_criteria_id] = prediction.response_id;  
                }else{
                  if(prediction.response_type.toLowerCase() === "scorerange"){
                    this.form_data[prediction.prediction_criteria_id] = this.score_range.find(score=>score.id === prediction.response_id);
                  }else{
                    this.form_data[prediction.prediction_criteria_id] = this.players.find(score=>score.id === prediction.response_id);
                  }
                }
                
              }
            }
          }
        }catch(err){
          if(err && err.data && err.data.message){
            this.$swal("Loading Failed",err.data.message,"error");
          }
        }
      },
      async submitForm(){
        if(!this.form_data || Object.values(this.form_data).length === 0){
          this.$swal("Invalid","Please enter atleast one prediction","error");
          return;
        }

        if(!this.is_changed){
          this.$swal("Invalid","Please update your prediction","error");
          return;
        }

        const predictions = Object.keys(this.form_data).map(data=>{
          const prediction_field = this.predictions.find(prediction=>prediction.id === Number(data));
          return {
            criteria_id:Number(data),
            response_id:typeof this.form_data[data] === "object" ? this.form_data[data].id : this.form_data[data],
            response_type:prediction_field.prediction_type
          }
        });
        this.isLoading = true;
        try{
          const data = await this.$axios.post(`/ipl/matches/${this.match_uuid}/predict`,{
            predictions:predictions
          });
          if(data && data.data && data.data.status){
            await this.$swal("Predictions","Success","success");
            this.$router.replace("/");
          }
          this.isLoading = false;
        }catch(err){
          if(err && err.data && err.data.message){
            this.$swal("Submit Failed",err.data.message,"error");
          }else{
            this.$swal("Submit Failed","Something went wrong!","error");
          }
          this.isLoading = false;
        }

      },
      getShortForm(name){
        return name ? name.split(" ").map(word=>word.trim()[0]).join(''):'';
      },
      formInvalid(){
        return (!this.form_data || Object.values(this.form_data).length === 0) || !this.is_changed;
      },
      valueChange(){
        this.$forceUpdate();
        this.is_changed = true;
      }
    },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
  .custom-radio{
    line-height: 1;
  }
  .custom-radio span {
    background: #E6E6E6;
    box-shadow: inset 0px 4px 0px rgba(0, 0, 0, 0.06);
  }
  .custom-radio span i {
    font-style: normal;
  }
  .custom-radio span .text-8 {
    font-style: normal;
    font-size: 8px;
  }

  .custom-radio input:checked~span {
    color: #fff;
    background: linear-gradient(180deg, #FF9C59 0%, #ED6C15 100%);
    box-shadow: inset 0px -4px 0px rgba(0, 0, 0, 0.16);
  }

  .btn-login {
    background: linear-gradient(180deg, #FF9C59 0%, #ED6C15 100%);
    -webkit-tap-highlight-color:transparent;
    box-shadow: inset 0px -4px 0px rgba(0, 0, 0, 0.16);
    border-radius: 10px;
  }

  .btn-login.disabled{
    background: linear-gradient(180deg, #FF9C5999 0%, #ED6C1599 100%);
    box-shadow: none;
  }
  .btn-login:active{
    outline: none;
    box-shadow: none;
  }
  .multiselect{
    @apply w-full border border-divider appearance-none focus:outline-none text-orange text-sm font-medium placeholder-black;
    box-sizing: border-box;
  }

</style>